<div class="wrapper">
  @if (!options?.hideHeader && !options?.hideHeading) {
    <div class="heading text-type-2">{{ data?.itemPostings?.item }}</div>
  }
  @if (options?.showSiteAndDate && (data?.siteName || data?.reportDate)) {
    <div class="site-report-info">
      {{ data?.siteName }}@if (data?.siteName && data?.reportDate) {
      <span> • </span>
      }{{ data?.reportDate | date: 'MMMM dd, yyyy' }}
    </div>
  }
  <div class="description text-type-10">{{ data?.itemPostings?.description }}</div>
  <div class="meta text-type-14">
    {{ data?.itemPostings?.source_entity_extra_attributes?.project_name }}
    · PRJ LINE: {{ data?.itemPostings?.source_entity_extra_attributes?.project_item_line_number }}
    · LINE: {{ data?.itemPostings?.source_entity_extra_attributes?.contract_item_line_number }}
    @if (data?.itemPostings?.source_entity_extra_attributes?.supplemental_description) {
      · {{ data?.itemPostings?.source_entity_extra_attributes.supplemental_description | uppercase }}
    }
  </div>
  <div class="uom text-type-14">UOM: {{ data?.itemPostings?.uom }}</div>
  <app-item-postings-details
    [data]="data"
  />
  @if (options?.showActionsSection === undefined || options?.showActionsSection) {
    <app-actions-section
      [disableAddMenu]="disableAddMenu"
      [hideLocationOption]="true"
      class="actions-section w-[455px]"
    />
  }
</div>
